export default __webpack_public_path__ + "abf056442f99afcc1b1021491a89d253.svg";